export default __webpack_public_path__ + "static/media/api-selected.5a92b32d.svg";